import operatorUserMapper from '../mappers/operatorUserMappers';
import {
  RETRIEVE_OPERATOR_USER_SUCCESS,
  OPERATOR_USER_EXPANDED,
  OPERATOR_USER_CHECKED,
  SELECT_ALL_OPERATOR_USER,
  DESELECT_ALL_OPERATOR_USER,
} from '../actions/types/OperatorUserTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import filterOperatorUserIfExistsInPostalOperators from '../filters/filterOperatorUserIfExistsInPostalOperator';

export const initialState = {
  nodes: [],
  checkedOperatorUser: [],
  expandedOperatorUser: [],
  selections: [],
};

const allChildNodeValues = nodes =>
  nodes.map(node => node.children.map(mPC => mPC.value))
    .reduce((initial, operatorUsers) => initial.concat(operatorUsers));

export const operatorUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OPERATOR_USER_SUCCESS:
      return {
        ...state,
        nodes: operatorUserMapper(action.payload),
        isLoading: false,
      };
    case OPERATOR_USER_EXPANDED:
      return {
        ...state,
        expandedOperatorUser: [...action.expandedOperatorUser],
      };
    case OPERATOR_USER_CHECKED:
      return {
        ...state,
        checkedOperatorUser: filterOperatorUserIfExistsInPostalOperators(
          action.checkedOperatorUser,
          state.nodes,
          action.reportDefinition,
        ),
      };
    case SELECT_ALL_OPERATOR_USER:
      return {
        ...state,
        checkedOperatorUser: allChildNodeValues(action.payload.nodes),
      };
    case DESELECT_ALL_OPERATOR_USER:
      return {
        ...state,
        checkedOperatorUser: [],
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

